import React from 'react';
import { ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { CurrencyNote } from './CurrencyNote';
import { alreadyGo } from '../data/content';
import { CtaButton } from './CtaButton';
import { LeafSprig } from './decor/LeafSprig';
const mechanism = ['Imprimez.', 'Découpez.', 'Partagez.', 'Semez la graine.'];
export function FinalClose() {
  return <section aria-labelledby="close-title" className="bg-paper" data-id="element-73" data-mp="i72d4iqo4bd0">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-74" data-mp="1freta4chrtgj">
        <div className="grid gap-14 lg:grid-cols-[1fr_460px] lg:items-center lg:gap-16" data-id="element-75" data-mp="1at3ls09o5v1h">
          <div data-id="element-76" data-mp="162n2w0n2xh7q">
            <h2 id="close-title" className="text-balance font-display text-[40px] leading-[1.04] text-navy sm:text-[54px]" data-id="element-77" data-mp="162500l5ww4qu">
              Combien de graines allez-vous semer cette semaine ?
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-ink-soft" data-id="element-78" data-mp="1yk9910hxvplt">
              Une autre semaine peut passer exactement comme la précédente. <strong className="text-navy" data-id="element-79" data-mp="1tr6asf27vrza">Ou bien, cette semaine peut être celle où vous commencez.</strong>
            </p>
            <ul className="mt-6 grid gap-2 text-lg text-ink-soft sm:grid-cols-2" data-id="element-80" data-mp="sofc9baepmoe">
              {alreadyGo.map(a => <li key={a} data-id="element-81" data-mp="e00yw6fd6ftl">{a}</li>)}
            </ul>
            <p className="mt-6 text-lg leading-relaxed text-ink-soft" data-id="element-82" data-mp="dxoj9zx2whjp">
              Les occasions sont déjà autour de vous. Désormais, vous pouvez avoir 200+ versets bibliques répartis sur 20+ modèles différents pour
              partager l’Évangile, prêts pour ces occasions.
            </p>
            <p className="mt-4 text-lg leading-relaxed text-ink-soft" data-id="element-83" data-mp="8y3c527r92vw">
              Vous n’avez pas besoin d’attendre de ne plus avoir peur. Vous n’avez pas besoin d’attendre de tout savoir.{' '}
              <strong className="text-navy" data-id="element-84" data-mp="1kvopgpn7g7">Il vous suffit d’être prêt à faire le premier pas.</strong>
            </p>
            <ol className="mt-8 flex flex-wrap gap-x-4 gap-y-1" data-id="element-85" data-mp="1udiudxhe8kxu">
              {mechanism.map((m, i) => <li key={m} className={`font-display text-3xl sm:text-4xl ${i === mechanism.length - 1 ? 'italic text-leaf-deep' : 'text-navy'}`} data-id="element-86" data-mp="1sx5171lfp7s9" data-mpi={i}>
                  {m}
                </li>)}
            </ol>
          </div>

          <div className="relative rounded-3xl bg-cream p-8 text-center shadow-sheet ring-2 ring-coral/25 sm:p-10" data-id="element-87" data-mp="1iyxxvlk2io8q">
            <LeafSprig className="absolute -right-3 -top-8 h-20 w-10 rotate-12 text-leaf/60" data-id="element-88" data-mp="1e15xs499rvtg" />
            <p className="font-display text-2xl leading-tight text-navy sm:text-[28px]" data-id="element-89" data-mp="2bmbluu5sg9gp">Obtenez le Pack Complet d’Évangélisation</p>
            <p className="mt-2 font-display text-[88px] leading-none text-coral" aria-label="$24.90" data-id="element-90" data-mp="21xa5h2vbzq27">
              $24<span className="align-top text-[44px] leading-none" data-id="element-91" data-mp="1wygrl9c4tx1i">.90</span>
            </p>
            <p className="mt-4 text-sm font-semibold leading-relaxed text-ink-soft" data-id="element-92" data-mp="2udl0fhuf1of5">
              200+ versets bibliques · 20+ modèles imprimables · 5 bonus · Accès numérique immédiat · Garantie de 7 jours
            </p>
            <CurrencyNote className="mt-6 border-t border-cream-line pt-5" data-id="element-93" data-mp="2xwabi46m4dgh" />
            <CtaButton checkout block className="mt-4" data-id="element-94" data-mp="31wu733bjf90i">
              Obtenir l’accès immédiat
            </CtaButton>
            <div className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-semibold text-ink-soft" data-id="element-95" data-mp="36vxdos761nal">
              <span className="inline-flex items-center gap-1.5" data-id="element-96" data-mp="3bwuv32kcqdb1">
                <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-97" data-mp="3gv645b2tojs7" />
                Accès numérique immédiat
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-98" data-mp="3ku56qp1304gh">
                <ShieldCheckIcon className="h-4 w-4 text-leaf-deep" aria-hidden="true" data-id="element-99" data-mp="3pnpuzpcvhk2h" />
                Garantie de 7 jours
              </span>
            </div>
          </div>
        </div>
        <p className="mx-auto mt-16 max-w-2xl text-center font-display text-2xl italic leading-snug text-navy sm:text-3xl" data-id="element-100" data-mp="3g9hf8gryw1l">
          Car quelqu’un que vous croiserez cette semaine a peut-être besoin du message que vous portez.
        </p>
      </div>
    </section>;
}